import { Code, Flex, IconButton, Link, Tooltip } from '@radix-ui/themes';
import { ExternalLinkIcon } from '@radix-ui/react-icons';

import CopyButton from '../CopyButton';

interface BlockNumberDisplayProps {
  blockNumber: number | string;
  label?: string;
  link?: string;
  isHighlighted?: boolean;
}

const BlockNumberDisplay = ({
  blockNumber,
  label,
  link,
  isHighlighted,
}: BlockNumberDisplayProps) => {
  const displayValue = label
    ? `${label} (${blockNumber.toLocaleString()})`
    : blockNumber.toLocaleString();
  const copyValue = blockNumber.toString();

  return (
    <Flex gap="2" align="center">
      <Tooltip content={`Block ${blockNumber.toLocaleString()}`}>
        {link ? (
          <Link href={link}>
            <Code variant={isHighlighted ? 'outline' : 'ghost'}>{displayValue}</Code>
          </Link>
        ) : (
          <Code variant={isHighlighted ? 'outline' : 'ghost'}>{displayValue}</Code>
        )}
      </Tooltip>
      <CopyButton value={copyValue} />
      {link && (
        <Tooltip content="Open in new tab">
          <IconButton size="1" variant="ghost" color="gray" asChild>
            <a href={link} target="_blank" rel="noopener noreferrer">
              <ExternalLinkIcon />
            </a>
          </IconButton>
        </Tooltip>
      )}
    </Flex>
  );
};

export default BlockNumberDisplay;
